import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

// Const
import { PATH_MY_ACCOUNT, PATH_TICKET_SUPPORT } from 'routes/paths'

// Api
import { getPaymentInfo } from 'api/payment'
import { getContractInfo } from 'api/contract'

// Helpers
import { resolveRouteUrl } from 'helpers'

// Notifications slice
import { markAsRead } from 'store/modules/notifications'

// Use
import { useHistory, useParams } from 'react-router-dom'
import useMounted from 'use/mounted'
import useQuery from 'use/query'

// Models
import ContractModel from 'models/Contract'
import PaymentBreakdownModel from 'models/PaymentBreakdown'

//Component
import Row from 'ui/Row'
import Col from 'ui/Col'
import Loading from 'ui/Loading'
import Header from 'ui/Header'
import Navbar from 'ui/Navbar'
import Container from 'ui/Container'
import Breadcrumb from 'ui/Breadcrumb'
import Footer from 'ui/Footer'
import PaymentOR from 'components/Payment/PaymentOR'
import PaymentSummary from 'components/Payment/PaymentSummary'
import PaymentBreakdown from 'components/Payment/PaymentBreakdown'
import PaymentReceived from 'components/Payment/PaymentReceived'
import NeedHelp from 'components/NeedHelp'

const breadcrumbs = [
  {
    label: 'Account & payments',
    path: PATH_MY_ACCOUNT,
  },
  {
    label: 'Payment details',
  },
]

export default function PagePaymentView() {
  const dispatch = useDispatch()
  const isMounted = useMounted()
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [contract, setContract] = useState(new ContractModel())
  const [paymentBreakdown, setPaymentBreakdown] = useState(
    new PaymentBreakdownModel()
  )

  const { paymentId, paymentMethod, contractNumber, vendorCode, companyCode } =
    useParams()

  const { notificationId, lessorId, companyId, vendorId } = useQuery()

  useEffect(() => {
    setLoading(true)
    getContractInfo({
      contractNumber,
      vendorCode,
      companyCode,
      notificationId,
    })
      .then((data) => {
        if (isMounted.current) {
          setContract(data)
        }
      })
      .finally(() => {
        if (isMounted.current) {
          setLoading(false)
        }
      })
  }, [companyCode, contractNumber, isMounted, notificationId, vendorCode])

  useEffect(() => {
    setLoading(true)

    dispatch(markAsRead(notificationId))

    getPaymentInfo({ paymentId, paymentMethod, notificationId })
      .then((data) => {
        if (isMounted.current) {
          setPaymentBreakdown(data)
        }
      })
      .finally(() => {
        if (isMounted.current) {
          setLoading(false)
        }
      })
  }, [
    companyCode,
    contractNumber,
    dispatch,
    isMounted,
    notificationId,
    paymentId,
    paymentMethod,
    vendorCode,
  ])

  const redirectToHSTicketing = () => {
    const url = resolveRouteUrl({
      path: PATH_TICKET_SUPPORT,
      query: {
        lessorId,
        companyId,
        companyCode,
        vendorId,
        vendorCode,
        contractNumber,
      },
    })

    history.push(url)
  }

  return (
    <>
      <Header />
      <Navbar />
      <Container>
        <Breadcrumb items={breadcrumbs} />
        <Loading spinning={loading}>
          <Row>
            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
              <PaymentSummary contract={contract} payment={paymentBreakdown} />
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12} md={8} lg={8} xl={8}>
              <PaymentBreakdown payment={paymentBreakdown} />
              <PaymentReceived payment={paymentBreakdown} />
              {!paymentBreakdown.isNonVat && (
                <>
                  <div
                    style={{
                      borderBottom: '1px solid #707070',
                      margin: '30px 0',
                    }}
                  ></div>
                  <PaymentOR payment={paymentBreakdown} />
                </>
              )}
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4}>
              <NeedHelp
                title="Need help ?"
                content={
                  'For any questions/concerns regarding your statement of account and payments, you may send us a message below'
                }
                textButton={'Raise a ticket'}
                onOpenPopup={redirectToHSTicketing}
              />
            </Col>
          </Row>
        </Loading>
      </Container>
      <Footer />
    </>
  )
}
